<template>
  <button class="see-more-button" @click="onClick">
    <div class="see-more-button__icon">
      <ArrowForwardPrimary class="see-more-button__arrow" />
    </div>
    <span class="see-more-button__text">もっとみる</span>
  </button>
</template>
<script>
import ArrowForwardPrimary from '../../atoms/svg_icons/ArrowForwardPrimary'
export default {
  components: { ArrowForwardPrimary },
  methods: {
    onClick() {
      this.$emit('click-button')
    }
  }
}
</script>
<style lang="scss" scoped>
.see-more-button {
  @extend %hover-common;
  width: 100%;
  max-width: 115px;
  min-width: 0;
  max-height: 115px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &__icon {
    margin-bottom: 4px;
    padding: 6px;
    border: 2px $primary solid;
    border-radius: 50%;
    font-size: 0;
  }

  &__arrow {
    width: 24px;
    height: 24px;
  }

  &__text {
    color: $primary;
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 2;
    letter-spacing: 0.06em;
  }
}
</style>
